// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__Ag1A9","header":"ClearentDisclaimer_header__1SImC","inner":"ClearentDisclaimer_inner__32mtX"};